export default __webpack_public_path__ + "static/media/error-icon.090e8a5a.svg";